import React, { useState, useMemo } from "react";
import styled from "styled-components";
import { MdOutlinePlaylistRemove } from "react-icons/md";

const NeuContainer = styled.div`
  backdrop-filter: blur(30px);
  background-color: var(--backdrop-color);
  border: 1px solid var(--color-grey-200);
  border-radius: 10px;
  cursor: pointer;
  box-shadow: var(--shadow-div-md);
  padding: 20px;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const NeuTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const NeuTh = styled.th`
  padding: 2px;
  text-align: left;
  color: var(--color-grey-500);
  cursor: pointer;
  user-select: none;

  &.ascending::after {
    content: " ▲";
  }

  &.descending::after {
    content: " ▼";
  }
`;

const NeuTd = styled.td`
  padding: 3px;
  text-align: left;
`;

const NeuTr = styled.tr`
  &:hover {
    background-color: var(--color-witron-blue);
  }
`;

const Row = styled.div`
  color: yellow;
`;

const DeleteIcon = styled(MdOutlinePlaylistRemove)`
  color: var(--color-red-700);
  cursor: pointer;
  margin-left: 10px;
`;

const DeleteTd = styled.td`
  text-align: right;
`;

const ListNeu = ({ data, headings, onRowClick = () => {}, onDelete }) => {
  const [sortConfig, setSortConfig] = useState({
    key: headings[0]?.key || "",
    direction: "descending",
  });

  const sortedData = useMemo(() => {
    if (!data) return [];

    let sortableData = [...data];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [data, sortConfig]);

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const getClassNamesFor = (name) => {
    if (!sortConfig) return;
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };

  return (
    <NeuContainer>
      <NeuTable>
        <thead>
          <tr>
            {headings.map((heading) => (
              <NeuTh
                key={heading.key}
                onClick={() => requestSort(heading.key)}
                className={getClassNamesFor(heading.key)}
              >
                {heading.label}
              </NeuTh>
            ))}
            {onDelete && <NeuTh></NeuTh>}
            {/* Empty header for delete icon */}
          </tr>
        </thead>
        <tbody>
          {sortedData.map((item) => (
            <NeuTr key={item.id} onClick={() => onRowClick(item)}>
              {headings.map((heading) => (
                <NeuTd key={heading.key}>{item[heading.key]}</NeuTd>
              ))}
              {onDelete && (
                <DeleteTd onClick={(e) => e.stopPropagation()}>
                  <DeleteIcon onClick={() => onDelete(item)} />
                </DeleteTd>
              )}
            </NeuTr>
          ))}
        </tbody>
      </NeuTable>
    </NeuContainer>
  );
};

export default ListNeu;
